import { useTranslation } from 'react-i18next'
import { IMcdPotentialTileData } from '../../../McdPotentialModel'

export interface BarData {
  [key: string]: {
    title: string
    paragraph: string
    datasets: {
      bar: {
        label1: string
        value: number
      }
      topLine: {
        label2?: string
        value: number
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useGetChartData = (data: IMcdPotentialTileData) => {
  const { t } = useTranslation()
  const barData = {
    transactions: {
      title: t('placeme.mcd_potential_model_tile.transactions'),
      paragraph: t('placeme.mcd_potential_model_tile.label.transactions'),
      datasets: {
        bar: {
          label1: t('placeme.mcd_potential_model_tile.label.transactions'),
          value: data?.value.potentialModel.transactions,
        },
        topLine: {
          label2: t('placeme.mcd_potential_model_tile.label.average_chain_transactions'),
          value: data?.value.potentialModel.averageChainTransactions,
        },
      },
    },
    sales: {
      title: t('placeme.mcd_potential_model_tile.sales'),
      paragraph: t('placeme.mcd_potential_model_tile.label.sales'),
      datasets: {
        bar: {
          label1: t('placeme.mcd_potential_model_tile.label.sales'),
          value: data?.value.potentialModel.sales,
        },
        topLine: {
          label2: t('placeme.mcd_potential_model_tile.label.average_chain_sales'),
          value: data?.value.potentialModel.averageChainSales,
        },
      },
    },
  }

  return barData
}
